import { addDays, daysBetween, localDate } from "./dates.js";

export const RANGE_PROBLEM = Object.freeze({
  MISSING_DATES: "MISSING_DATES",
  END_BEFORE_START: "END_BEFORE_START",
  SPAN_TOO_LONG: "SPAN_TOO_LONG",
  STARTS_TOO_SOON: "STARTS_TOO_SOON",
});

const MAX_SPAN_DAYS = 30;
const MIN_LEAD_DAYS = 14;

const hasDates = ({ eventStartDate, eventEndDate, timeZone }) =>
  Boolean(eventStartDate && eventEndDate && timeZone);

export const rangeProblems = (event) =>
  !hasDates(event)
    ? [RANGE_PROBLEM.MISSING_DATES]
    : event.eventEndDate < event.eventStartDate
    ? [RANGE_PROBLEM.END_BEFORE_START]
    : daysBetween(event.eventStartDate, event.eventEndDate) > MAX_SPAN_DAYS
    ? [RANGE_PROBLEM.SPAN_TOO_LONG]
    : [];

export const leadTimeProblems =
  ({ now }) =>
  (event) =>
    hasDates(event) &&
    event.eventStartDate <
      addDays(localDate(now, event.timeZone), MIN_LEAD_DAYS)
      ? [RANGE_PROBLEM.STARTS_TOO_SOON]
      : [];
